import React from 'react';

// Components
import * as S from './Styled';
import Input from '../../Input';
import Checkbox from '../../Checkbox';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Button';

const Signup = ({ onLogin }) => {
  let { t } = useTranslation();
  return (
    <S.Signup>
      <S.Form>
        <S.Title>{t('labels.registration')}</S.Title>
        <S.Row>
          <S.Column>
            <Input label={t('labels.name')} />
          </S.Column>
          <S.Column>
            <Input label={t('labels.last_name')} />
          </S.Column>
        </S.Row>
        <S.Row>
          <S.Column>
            <Input label={t('labels.phone')} />
          </S.Column>
          <S.Column>
            <Input label={t('labels.email')} />
          </S.Column>
        </S.Row>
        <S.Row>
          <S.Column>
            <Input label={t('labels.password')} />
          </S.Column>
          <S.Column>
            <Input label={t('labels.repeat_password')} />
          </S.Column>
        </S.Row>
        <S.Row>
          <S.Column>
            <Checkbox type={'primary'}>
              {t('labels.i_agree_with')}{' '}
              <S.Rules to="">{t('labels.the_terms_of_use')}</S.Rules>{' '}
              {t('labels.of_the_service')}
            </Checkbox>
          </S.Column>
        </S.Row>
        <S.Row>
          <S.Column>
            <Button size="middle" type="primary" htmlType="submit">
              {t('buttons.sign_up')}
            </Button>
          </S.Column>
        </S.Row>
      </S.Form>
      <S.Footer>
        <S.BText>
          {t('labels.already_have_an_account')}
          <S.LoginLink onClick={onLogin}>{t('labels.log_in')}</S.LoginLink>
        </S.BText>
      </S.Footer>
    </S.Signup>
  );
};

export default Signup;
